import React, { useEffect, useState } from "react";
import { Row, Input, Form, Select, Col, Spin, Radio } from "antd";

import { FONT, ROLE_ADMIN, ROLE_ADMIN_CUSTOMER } from "constants/index";
import { getUsers } from "services/user/user-service";
import { notificationErroInternal } from "util/api-utils";

const BranchCreateClient = ({ form }) => {
  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    getcustomers();
  }, []);

  const getcustomers = async () => {
    setLoading(true);
    try {
      const users = await getUsers();
      const customers = users
        .filter(
          (item) => item.role == ROLE_ADMIN_CUSTOMER || item.role == ROLE_ADMIN
        )
        .map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
      setCustomers(customers);
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <Spin spinning={loading}>
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="name"
              label={<span style={{ fontFamily: FONT }}>Nome</span>}
              rules={[
                { required: true, message: "É necessário informar o nome" },
              ]}
            >
              <Input style={{ fontFamily: FONT }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="role"
              label={<span style={{ fontFamily: FONT }}>Tipo</span>}
              style={{ height: "40px" }}
              rules={[
                { required: true, message: "É necessário informar o tipo" },
              ]}
            >
              <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.children ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
                options={[
                  {
                    value: "ESPORTIVO",
                    label: "Centro Esportivo",
                  },
                  {
                    value: "AQUATICO",
                    label: "Centro Aquativo",
                  },
                ]}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="owner"
              label={<span style={{ fontFamily: FONT }}>Administrador</span>}
              style={{ height: "40px" }}
              rules={[
                {
                  required: true,
                  message: "É necessário informar o administrador",
                },
              ]}
            >
              <Select
                disabled
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.children ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
                options={customers}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="hasPhotocell"
              label={
                <span style={{ fontFamily: FONT }}>Possui Fotocélula?</span>
              }
            
            >
              <Radio.Group>
                <Radio value={true}>Sim</Radio>
                <Radio value={false}>Não</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} style={{ padding: 2, paddingTop: 10 }}>
          <Col span={24}>
            <Form.Item
              name="webhook"
              label={<span style={{ fontFamily: FONT }}>Webhook</span>}
              style={{ height: "40px" }}
            >
              <Input style={{ fontFamily: FONT }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} style={{ padding: 2, paddingTop: 10 }}>
          <Col span={24}>
            <Form.Item
              name="eventList"
              label={<span style={{ fontFamily: FONT }}>Eventos Webhook</span>}
              style={{ height: "40px" }}
            >
              <Select
                mode="multiple"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
                options={[
                  { label: "Proxímo Nivel", value: "NEXT_LEVEL" },
                  { label: "Proxíma Fase", value: "NEXT_PHASE" },
                  { label: "Objetivo Concluído", value: "OBJECTIVE_DONE" },
                ]}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} style={{ padding: 2, paddingTop: 10 }}>
          <Col span={12}>
            <Form.Item
              name="evoUser"
              label={<span style={{ fontFamily: FONT }}>Usuário Evo</span>}
              style={{ height: "40px" }}
            >
              <Input style={{ fontFamily: FONT }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="evoPass"
              label={<span style={{ fontFamily: FONT }}>Senha Evo</span>}
              style={{ height: "40px" }}
            >
              <Input style={{ fontFamily: FONT }} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};
export default BranchCreateClient;
